"use client";


import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import BottomCta from "@/components/BottomCta";
import { useState } from "react";
import { ChevronDown } from "lucide-react";

import FreeZoneHero from "@/components/freezone/FreeZoneHero";
import BenefitsSection from "@/components/freezone/BenefitsSection";
import FreeZoneSection from "@/components/freezone/FreeZoneSection";

const BENEFITS = [
  
  {
    title: "Retain Ownership",
    description:
      "The main advantage offered by the UAE free zones is that foreign investors can retain 100% ownership of their ...",
    image: "retain.webp",
    icon: (
      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#B8893A" strokeWidth="2">
        <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
      </svg>
    ),
  },

  {
    title: "Business License",
    description:
      "Some business categories require prior approvals from certain authorities. Contact us today for a free ...",
    image: "licence.webp",
    icon: (
      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#B8893A" strokeWidth="2">
        <line x1="12" y1="1" x2="12" y2="23" />
        <path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6" />
      </svg>
    ),
  },

  {
    title: "Financial Incentives",
    description:
      "Other financial incentives of free zones includes a 0% income tax rate, no customs duties levied on imports ...",
    image: "financial.webp",
    icon: (
      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#B8893A" strokeWidth="2">
        <polyline points="17 1 21 5 17 9" />
        <path d="M3 11V9a4 4 0 0 1 4-4h14" />
        <polyline points="7 23 3 19 7 15" />
        <path d="M21 13v2a4 4 0 0 1-4 4H3" />
      </svg>
    ),
  },

  {
    title: "Sector-Specific",
    description:
      " Another factor that can present fantastic opportunities to free zone companies is that ...",
    image: "sector.webp",
    icon: (
      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#B8893A" strokeWidth="2">
        <circle cx="12" cy="12" r="10" />
        <path d="M8.56 2.75c4.37 6.03 6.02 9.42 8.03 17.72" />
      </svg>
    ),
  },
];

const FAQS = [
  {
    question: "How do I choose the right Free Zone?",
    answer:
      "We assess your business activity, budget, visa requirements, and long-term goals to recommend the most suitable free zone.",
  },
  {
    question: "Do I need to handle the paperwork myself?",
    answer:
      "No. Our team manages the entire documentation and application process on your behalf while keeping you informed at every stage.",
  },
  {
    question: "How long does the license application process take?",
    answer:
      "The timeline varies by free zone, but most applications are processed quickly once all required documents are submitted.",
  },
  {
    question: "When will I receive my trade license?",
    answer:
      "After approval from the relevant authority, your trade license is issued and your company becomes officially registered.",
  },
  {
    question: "Can you help with bank accounts and visas?",
    answer:
      "Yes. We assist with corporate bank account opening and handle investor, employee, and dependent visa applications.",
  },
];


export default function FreeZonePage() {
const [open, setOpen] = useState(null);
  return (
    <main className="min-h-screen bg-[#FAFAFA]">
      <Navbar />
      <FreeZoneHero
        badge="Free Zone Company Setup"
        title="Get Your Free Zone"
        highlight="Company Right"
        subtitle="With over 50 free zones in the UAE, how do you know which one is best for you? AWS Businessmen walks you through it step-by-step saving you money and making the entire experience stress-free."
        cta1={{ href: "/contact", label: "Get Started" }}
        cta2={{ href: "/calculator", label: "Calculate Your Cost" }}
        image="/FZ.webp"
      />
      <BenefitsSection benefits={BENEFITS} />
       <FreeZoneSection />


     <section className="py-14 sm:py-20 lg:py-14 px-4 sm:px-6 lg:px-10 bg-[#FAFAFA]">
  <div className="max-w-full mx-auto">

    <div className="text-left md:text-center mb-12">
      <p className="text-xs sm:text-sm font-bold text-[#B8893A] uppercase tracking-widest mb-3">
        Frequently Asked Questions
      </p>

      <h2
        className="font-bold text-[#000000]"
        style={{
          fontSize: "clamp(28px, 5vw, 48px)",
          lineHeight: "1.3",
        }}
      >
        Everything You Need to Know
      </h2>
    </div>

    <div className="space-y-4">
      {FAQS.map((faq, index) => (
        <div
          key={index}
          className="border border-[#e7e7e7] rounded-2xl overflow-hidden bg-white"
        >
          <button
            onClick={() =>
              setOpen(open === index ? null : index)
            }
            className="w-full flex items-center justify-between p-5 text-left"
          >
            <span className="font-semibold text-black text-base md:text-lg">
              {faq.question}
            </span>

            <ChevronDown
              className={`transition-transform duration-300 ${
                open === index ? "rotate-180" : ""
              }`}
            />
          </button>

          <div
            className={`overflow-hidden transition-all duration-300 ${
              open === index
                ? "max-h-40 opacity-100"
                : "max-h-0 opacity-0"
            }`}
          >
            <div className="px-5 pb-5 text-gray-500 leading-relaxed">
              {faq.answer}
            </div>
          </div>
        </div>
      ))}
    </div>

  </div>
</section>

   

      <BottomCta
        title="Ready to Start Your Free Zone Company?"
        subtitle="Our experts guide you from day one — transparent pricing, fast execution, zero stress."
      />
      <Footer />
    </main>
  );
}
